function logOutAndRedirect() {
    document.forms["logout-form"].submit();
}

export default logOutAndRedirect;
